import { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";

import location from "../assets/location.png";
import mail from "../assets/mail.png";
import phone from "../assets/phone.png";
import mapImage from "../assets/Map.png";   // ← your map PNG

export default function GetInTouch() {
  const formRef = useRef();

  // MAP refs
  const mapWrapRef = useRef(null);
  const mapRef = useRef(null);
  const lightRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");

  /* ================= EMAIL SEND ================= */
  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    emailjs
      .sendForm(
        "service_i9n4swj",      // YOUR SERVICE ID
        "template_n6ve0bo",     // YOUR TEMPLATE ID
        formRef.current,
        "7Sh-ggB8D4ARN0Asd"     // YOUR PUBLIC KEY
      )
      .then(() => {
        setLoading(false);
        setStatus("SUCCESS");
        formRef.current.reset();
      })
      .catch(() => {
        setLoading(false);
        setStatus("ERROR");
      });
  };

  /* ================= MAP BREATHING ZOOM ================= */
  useEffect(() => {
    let frame;
    let scale = 1.04;
    let dir = 1;

    const animate = () => {
      if (!mapRef.current) return;

      scale += dir * 0.0005;
      if (scale > 1.08 || scale < 1.04) dir *= -1;

      mapRef.current.style.transform = `scale(${scale})`;
      frame = requestAnimationFrame(animate);
    };

    animate();
    return () => cancelAnimationFrame(frame);
  }, []);

  /* ================= MAP PARALLAX + SPOTLIGHT ================= */
  useEffect(() => {
    const move = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 25;
      const y = (e.clientY / window.innerHeight - 0.5) * 25;

      if (mapWrapRef.current) {
        mapWrapRef.current.style.transform =
          `translate3d(${x}px, ${y}px, 0) rotateX(${y * -0.15}deg) rotateY(${x * 0.15}deg)`;
      }

      if (lightRef.current) {
        const px = (e.clientX / window.innerWidth) * 100;
        const py = (e.clientY / window.innerHeight) * 100;
        lightRef.current.style.background =
          `radial-gradient(circle at ${px}% ${py}%, rgba(34,197,94,0.25), transparent 45%)`;
      }
    };

    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);

  return (
    <section id="contact" className="bg-white py-28">
      <div className="max-w-7xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Get in <span className="text-primary">Touch</span>
          </h2>
          <p className="mt-4 text-gray-600">
            Ready to explore opportunities? We'd love to hear from you.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* ================= FORM ================= */}
          <div className="bg-white rounded-3xl border border-gray-100 shadow-lg p-8 md:p-10">
            <form ref={formRef} onSubmit={sendEmail} className="space-y-6">

              <div>
                <label className="block text-sm font-medium mb-2">Full Name</label>
                <input
                  type="text"
                  name="user_name"
                  required
                  className="w-full rounded-xl border px-4 py-3 text-sm focus:ring-2 focus:ring-primary"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Email</label>
                <input
                  type="email"
                  name="user_email"
                  required
                  className="w-full rounded-xl border px-4 py-3 text-sm focus:ring-2 focus:ring-primary"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">Message</label>
                <textarea
                  rows="4"
                  name="message"
                  required
                  className="w-full rounded-xl border px-4 py-3 text-sm focus:ring-2 focus:ring-primary"
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-primary text-white rounded-full py-3 font-medium hover:bg-green-600 transition"
              >
                {loading ? "Sending..." : "Send Message →"}
              </button>

              {status === "SUCCESS" && (
                <p className="text-green-600 text-sm text-center">
                  ✅ Message sent successfully!
                </p>
              )}

              {status === "ERROR" && (
                <p className="text-red-600 text-sm text-center">
                  ❌ Failed to send. Try again.
                </p>
              )}
            </form>
          </div>

          {/* ================= CONTACT + MAP ================= */}
          <div>

            <h3 className="text-2xl md:text-3xl font-bold mb-10">Headquarters</h3>

            <div className="space-y-6 mb-10">
              <div className="flex gap-4 items-center">
                <img src={location} className="h-6 w-6" alt="location"/>
                <p>Enam Sambhav PLOT-C-20 'G' BLOCK,BKC, BANDRA KURLA COMPLEX,<br/> MUMBAI - 400051</p>
              </div>

              <div className="flex gap-4 items-center">
                <img src={mail} className="h-6 w-6" alt="mail"/>
                <p>contact@yieldventures.co</p>
              </div>

              <div className="flex gap-4 items-center">
                <img src={phone} className="h-6 w-6" alt="phone"/>
                <p>+91 9100056333</p>
              </div>
            </div>

            {/* ================= ULTRA PREMIUM MAP ================= */}
            <div
              ref={mapWrapRef}
              className="
                relative overflow-hidden rounded-3xl
                border border-white/20
                shadow-[0_25px_80px_rgba(0,0,0,0.18)]
                backdrop-blur-md
                transition-transform duration-200
              "
              style={{ perspective: "1200px" }}
            >
              <div ref={lightRef} className="absolute inset-0 pointer-events-none z-20" />

              <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-black/10 z-10" />

              <img
                ref={mapRef}
                src={mapImage}
                alt="Location Map"
                className="w-full h-[160px] md:h-[220px] object-cover will-change-transform"
              />

              <div className="absolute inset-0 rounded-3xl border border-primary/20 pointer-events-none" />
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
